import { PLANS, APP_URL } from "../data/content";

export default function PricingGrid() {
  return (
    <div className="price-grid">
      {PLANS.map((plan, i) => (
        <div className={`pc${plan.pop ? " pop" : ""}`} key={i}>
          {plan.tag && <div className="pop-badge">{plan.tag}</div>}

          <div className="p-name">{plan.name}</div>
          <div className="p-amt"><sup>₹</sup>{plan.price}</div>
          <div className="p-period">{plan.period}</div>

          {/* Saving badge */}
          {plan.savingLabel ? (
            <div className="p-saving">{plan.savingLabel}</div>
          ) : (
            <div className="p-saving p-saving-empty"> </div>
          )}

          {/* Per-day cost */}
          {plan.perDay && (
            <div className="p-perday">
              <span className="p-perday-val">{plan.perDay}</span> per day
            </div>
          )}

          {/* Who it's for */}
          <div className="p-forwho">{plan.forWho}</div>

          <hr className="p-hr" />

          <ul className="p-feats">
            {plan.feats.map((feat, j) => (
              <li key={j}>
                <div className="p-ck">✓</div>
                <span>{feat}</span>
              </li>
            ))}
          </ul>

          <a
            href={APP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="p-btn"
          >
            {plan.cta}
          </a>
        </div>
      ))}
    </div>
  );
}
